import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { styled } from "styled-components";

const Copyright = styled.div`
  flex: 1;
  text-align: left;
  display: none;
  @media (min-width: 992px) {
    text-align: left;
    display: block;
  }
`;

const Wrapper = styled.div`
  display: flex;
  font-size: 14px;
  margin-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  text-transform: uppercase;
`;

const StyledNavLink = styled(Nav.Link)`
  display: none;
  text-transform: uppercase;
  padding: 0 0 0 2rem;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  @media (min-width: 992px) {
    display: block;
  }
`;

const ExternalLink = styled.a`
  display: none;
  text-transform: uppercase;
  padding: 0 0 0 2rem;
  text-decoration: none;
  color: var(--primary-color);

  &:hover {
    text-decoration: underline;
    color: var(--primary-color);
  }

  @media (min-width: 992px) {
    display: block;
  }
`;

const Base64DecodeInfo = () => {
  return (
    <Wrapper>
      <Copyright>&copy; TOOLWEAVER {new Date().getFullYear()}</Copyright>
      <Nav>
        <StyledNavLink as={Link} to="/privacypolicy">
          Privacy Policy
        </StyledNavLink>
        <StyledNavLink as={Link} to="/termsandconditions">
          Terms & Conditions
        </StyledNavLink>
        <StyledNavLink as={Link} to="/contact">
          Contact
        </StyledNavLink>
        <ExternalLink href="https://domainfindr.com" target="_blank">
          DomainFindr
        </ExternalLink>
        <ExternalLink href="https://massgenerate.com" target="_blank">
          MassGenerate
        </ExternalLink>
      </Nav>
    </Wrapper>
  );
};

export default Base64DecodeInfo;
